// Enveloppe commune des aperçus : une illustration (role="img" + description),
// dont le contenu est caché aux lecteurs d'écran. data-visible passe à true à
// l'apparition à l'écran et déclenche les animations CSS (apercus.css).
// boucle : l'animation se répète (haut de page uniquement).
import React from "react";
import useApparition from "../useApparition";

export default function Apercu({ description, className = "", boucle = false, children, style }) {
	const [ref, visible] = useApparition(0.3);
	return (
		<div
			ref={ref}
			className={`gs-apercu${boucle ? " gs-apercu--boucle" : ""} ${className}`.trim()}
			data-visible={visible}
			role="img"
			aria-label={description}
			style={style}
		>
			<div className="gs-apercu-contenu" aria-hidden="true">
				{children}
			</div>
		</div>
	);
}
